import { IncentiveTooltip } from '@components/shared/essential-ui/tooltip/ToolTip';
import { Icon } from '@components/style/Icon';
import { theme } from '@theme';
import React, { FC } from 'react';
import styled from 'styled-components';

type PrivateIncentiveIconProps = {
  toolTipText: string;
  click: (e: React.MouseEvent<HTMLSpanElement>) => void;
  color?: string;
  size: number;
};

const PrivateIncentiveIcon: FC<PrivateIncentiveIconProps> = (props) => {
  return (
    <IconWrapper {...props} data-testid='private-incentive-icon' onClick={props.click}>
      <Icon
        data-testid='private-incentive-icon'
        data-tooltip-id='PrivateIncentiveIcon'
        data-tooltip-content={props.toolTipText}
        type='private-incentive'
        size={props.size}
        color={props.color ?? theme.palette.text.purple}
      />
      <IncentiveTooltip data-testid='tooltip' id='PrivateIncentiveIcon' />
    </IconWrapper>
  );
};

export default PrivateIncentiveIcon;

const IconWrapper = styled.span<PrivateIncentiveIconProps>`
  position: relative;
`;
